import apiClient from '../apiClient';

interface SizingFeedbackRequest {
	user_id: string;
	size_label: string;
	product_url: string;
	feedback: boolean;
}

export const sendSizingFeedback = async (token: string, feedbackData: SizingFeedbackRequest): Promise<void> => {
	try {
		await apiClient('/sizes/sizing_feedback', {
			method: 'POST',
			headers: { Authorization: `Bearer ${token}` },
			body: JSON.stringify(feedbackData),
		});

		console.debug('✅ [SIZING_FEEDBACK] Feedback sent successfully');
	} catch (error) {
		console.error('❌ [SIZING_FEEDBACK] Error sending feedback:', error);
		throw error;
	}
};